import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/jetspeak/jetclass-web/govoriru/app/app.tsx");
;
import(/* webpackMode: "eager" */ "/builds/jetspeak/jetclass-web/govoriru/scss/_main.scss");
;
import(/* webpackMode: "eager" */ "/builds/jetspeak/jetclass-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/jetspeak/jetclass-web/node_modules/next/font/local/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../fonts/Montserrat-latin-cyrillic.woff2\",\"weight\":\"100 900\",\"style\":\"normal\",\"display\":\"swap\"}],\"variableName\":\"nextMontserrat\"}");
